import api from './api';
import { CreateReviewDTO, Review, UpdateReviewDTO } from '../types/review';

export const reviewService = {
  getMyTaskReview: async (taskId: number): Promise<Review> => {
    const response = await api.get<Review>(`/api/v1/reviews/task/${taskId}/mine`);
    return response.data;
  },

  createReview: async (payload: CreateReviewDTO): Promise<Review> => {
    const response = await api.post<Review>('/api/v1/reviews', payload);
    return response.data;
  },

  updateReview: async (reviewId: number, payload: UpdateReviewDTO): Promise<Review> => {
    const response = await api.patch<Review>(`/api/v1/reviews/${reviewId}`, payload);
    return response.data;
  },

  deleteReview: async (reviewId: number): Promise<void> => {
    await api.delete(`/api/v1/reviews/${reviewId}`);
  },
};
